module.exports = __webpack_public_path__ + "images/59551dbbb5320f3ba649aadca050af6d.jpg";